import type { OtherSaleCategory, OtherSalePaymentMethod, OtherSaleStatus, OtherSaleTaxMode } from '../types/otherSales';

export interface OtherSaleActionVisibility {
  canEdit: boolean;
  canDeleteDraft: boolean;
  canConfirm: boolean;
  canCancel: boolean;
}

/**
 * Fase 18D: qué acciones de escritura debe ofrecer la pantalla de Ventas Otros según el estado de
 * la venta. Extraída como función pura (mismo criterio que expenseActions.ts) para poder probar la
 * regla sin renderizar componentes.
 *
 * - DRAFT: se puede editar, eliminar físicamente y confirmar.
 * - CONFIRMED: no se puede editar ni eliminar físicamente — solo anular (con motivo obligatorio).
 * - CANCELLED: de solo lectura — no editar, no eliminar, no confirmar, no anular de nuevo.
 */
export function getOtherSaleActions(status: OtherSaleStatus): OtherSaleActionVisibility {
  return {
    canEdit: status === 'DRAFT',
    canDeleteDraft: status === 'DRAFT',
    canConfirm: status === 'DRAFT',
    canCancel: status === 'CONFIRMED',
  };
}

export const OTHER_SALE_CATEGORY_LABELS: Record<OtherSaleCategory, string> = {
  MANUAL_SALE: 'Venta manual',
  EVENT: 'Evento',
  SPECIAL_ORDER: 'Pedido especial',
  WHOLESALE: 'Mayoreo',
  DELIVERY_APP: 'App / plataforma externa',
  ADJUSTMENT: 'Ajuste positivo',
  OTHER: 'Otro ingreso',
};

export const OTHER_SALE_PAYMENT_METHOD_LABELS: Record<OtherSalePaymentMethod, string> = {
  CASH: 'Efectivo',
  CARD: 'Tarjeta',
  TRANSFER: 'Transferencia',
  OTHER: 'Otro',
};

export const OTHER_SALE_STATUS_LABELS: Record<OtherSaleStatus, string> = {
  DRAFT: 'Borrador',
  CONFIRMED: 'Confirmado',
  CANCELLED: 'Anulado',
};

export const OTHER_SALE_TAX_MODE_LABELS: Record<OtherSaleTaxMode, string> = {
  NONE: 'Sin IVA',
  INCLUDED: 'IVA Incluido',
  CUSTOM: 'Otros/Especificar',
};
